import { PaymentResultContent } from "../../features/payment";

function PaymentResultScreen() {
  return (
    <section className="payPage-section" id="Csection" tabIndex="-1">
      <div className="container">
        <PaymentResultContent />
      </div>
    </section>
  );
}

export default PaymentResultScreen;
